export { TENANTS } from "./tenants";
